import Chip from '@mui/material/Chip';
import { alpha } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';

import {
  CardIcon,
  CrownIcon
} from 'reservations/guests/components/StatusBadgeIcons';

interface Props {
  label: string;
  icon?: React.JSX.Element;
}

const BaseChip = ({ label, icon }: Props) => (
  <Chip
    label={label}
    icon={icon}
    sx={theme => ({
      backgroundColor: alpha(theme.typography.body1.color as string, 0.15),
      height: '100%',
      '& svg': {
        marginLeft: '9px'
      },
      '& .MuiChip-label': {
        typography: 'body1',
        paddingLeft: '5px'
      }
    })}
  />
);

export const HostBadge = () => {
  const theme = useTheme();
  return (
    <BaseChip
      label="Host"
      icon={<CrownIcon fillColor={theme.typography.body1.color} />}
    />
  );
};

export const ChecklessBadge = () => {
  const theme = useTheme();
  return (
    <BaseChip
      label="Enrolled"
      icon={<CardIcon fillColor={theme.typography.body1.color} />}
    />
  );
};

export const SplitRequestedBadge = () => <BaseChip label="Split requested" />;
